import { inject, injectable } from "tsyringe";
import { replaceString } from "src/libs/replace-string";
import { CardProtectionRoutes } from "src/containers/card-protection/core/routes";
import { cardProtectionPlusGroupCodes } from "src/containers/card-protection/core/constants";
import baseCoverages from "src/containers/card-protection/core/data/coverages-base";
import plusCoverages from "src/containers/card-protection/core/data/coverages-plus";
import { autoBind } from "src/shared/decorators/autobind";

type Coverage = {
    icon?: JSX.Element;
    text: string;
    path: string;
};

@injectable()
export class CardProtectionCoverageViewModel {
    private isPlus: boolean;

    constructor(@inject("GroupCode") groupCode: string) {
        const plusGroupCodes = cardProtectionPlusGroupCodes;

        this.isPlus = plusGroupCodes.includes(groupCode);
    }

    private buildCoverageUrl =
        (coverageId: string | number) =>
        (systemCode: string, productCode: string, policyId: string) => {
            return replaceString(CardProtectionRoutes.InsuranceCoverage, {
                ":productCode": productCode,
                ":systemCode": systemCode,
                ":policyId": policyId,
                ":coverageId": coverageId,
            });
        };

    @autoBind
    getCoverages() {
        return this.isPlus ? plusCoverages : baseCoverages;
    }

    @autoBind
    getCoveragesList(
        systemCode: string,
        productCode: string,
        policyId: string
    ): Coverage[] {
        return this.getCoverages().map((coverage) => ({
            icon: coverage.icon,
            text: coverage.shortTitle,
            path: this.buildCoverageUrl(coverage.id)(
                systemCode,
                productCode,
                policyId
            ),
        }));
    }

    @autoBind
    getCoverage(coverageId: string) {
        return this.getCoverages().find((c) => c.id === coverageId);
    }
}
